<div class="row" *ngIf="inspection">
  <inspection-edit
    [processing]="processing"
    [inspection]="inspection"
    [statusList]="statusList"
    (toggleSaveInspection)="saveInspection($event)"
    (toggleCancel)="cancel()"
  ></inspection-edit>
</div>
